import React from 'react';
import siteMapService from '../../services/site-map-service/site-map-service';
import { OwnerManualProps } from '../owner-manual/hook/use-owner-manual-content';

interface OwnerManualBreadcrumbsProps {
    currentRoot: string;
    ownerManualContent: OwnerManualProps | null;
    serverContext: any;
}
export const OwnerManualBreadcrumbLink = (
    props: OwnerManualBreadcrumbsProps
) => {
    return (
        <>
            <a
                className="breadcrumb-link"
                href={`${
                    props.currentRoot
                }${siteMapService.getPathFromRouterConfigs(
                    props.serverContext.currentLanguageRegionCode,
                    props.serverContext.brand,
                    'OwnerManualPage',
                    []
                )}`}
            >
                <span>{props.ownerManualContent?.title}</span>
            </a>
            <span className="back-slash">{'>'}</span>
        </>
    );
};
